import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import { Constants } from 'src/Constants'
import Swal from 'sweetalert2'
import useAuthStore from 'src/hooks/useAuthStore'

const Settings = () => {
  const { token } = useAuthStore()
  const [adminData, setAdminData] = useState({
    username: '',
    password: '',
  })
  const [confirmPassword, setConfirmPassword] = useState('')
  const [passwordMismatchError, setPasswordMismatchError] = useState('')


  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await fetch(Constants.getAdminDetails, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'admin-auth-token': token,
          },
        })

        if (response.ok) {
          const data = await response.json()
          setAdminData(data)
        } else {
          console.error('Failed to fetch admin data')
        }
      } catch (error) {
        console.error('Error fetching admin data', error)
      }
    }

    if (token) {
      fetchAdminData()
    }
  }, [token])

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value)
  }

  const handleSaveProfileSettings = async () => {
    try {
      if (!adminData || !adminData?.username.trim()) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Username is required',
        });
        return;
      }
  
      if (!adminData.password?.trim()) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Password is required',
        });
        return;
      }
      if (adminData?.password !== confirmPassword) {
        setPasswordMismatchError('* Password does not match')
        return
      }

      setPasswordMismatchError('Password matches');

      const response = await fetch(Constants.registerOrUpdateAdmin, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'admin-auth-token': token,
        },
        body: JSON.stringify({
          username: adminData?.username,
          password: adminData?.password,
        }),
      })

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Profile details saved successfully',
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to save profile details',
        })
      }
    } catch (error) {
      console.error('Error saving profile details:', error);
    }
  }
  const handleUsernameChange = (e) => {
    setAdminData((prevData) => ({
      ...prevData,
      username: e.target.value,
    }))
  }

  const handlePasswordChange = (e) => {
    setAdminData((prevData) => ({
      ...prevData,
      password: e.target.value,
    }))
  }



  return (
    <div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Row>
              <Col>
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 text-info">SETTINGS</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/dashboard">Home</Link>
                      </li>
                      <li className="breadcrumb-item active text-info">Settings</li>
                    </ol>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={16}>
                <div className="card custom-shadow rounded-lg border my-2 mb-4">
                  <div className="card-body">
                    <h5 className="mb-4">Profile Settings</h5>
                    <Form>
                      <Form.Group controlId="username">
                        <Form.Label>UserName</Form.Label>
                        <Form.Control
                          type="email"
                          value={adminData?.username}
                          onChange={handleUsernameChange}
                        />
                      </Form.Group>

                      <Form.Group controlId="password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          type="password"
                          value={adminData?.password}
                          onChange={handlePasswordChange}
                        />
                      </Form.Group>
                      <Form.Group controlId="confirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          type="password"
                          value={confirmPassword}
                          onChange={handleConfirmPasswordChange}
                        />
                        {passwordMismatchError && (
                          <p
                            style={{
                              color: passwordMismatchError.includes('not') ? 'red' : 'green',
                            }}
                          >
                            {passwordMismatchError}
                          </p>
                        )}
                      </Form.Group>

                      <Button
                        variant="primary"
                        className="my-2"
                        onClick={handleSaveProfileSettings}
                      >
                        Save Profile Details
                      </Button>
                    </Form>
                  </div>
                </div>
              
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings
